import { render } from "./SendInvoice.vue?vue&type=template&id=5126ddb8"
import script from "./SendInvoice.vue?vue&type=script&lang=js"
export * from "./SendInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__